import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../../services/authService';
import PasswordInput from './PasswordInput';
import './styles/Login.css';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    setSubmitting(true);
    try {
      const data = await registerUser({ email, password, businessName, phone });
      setMsg(data?.message || 'OTP sent');
      navigate('/verify', { state: { email } });
    } catch (err) {
      setError(err?.response?.data?.message || 'Registration failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-eyebrow">
            <span className="auth-eyebrow-dot" aria-hidden="true" />
            ALG Data Guard
          </div>
          <h2 className="auth-title">Create account</h2>
          <p className="auth-subtitle">Register your business and verify with OTP.</p>
        </div>

        {msg && (
          <div className="auth-alert" role="alert"
            style={{ borderColor: 'rgba(34,197,94,0.25)', background: 'rgba(34,197,94,0.07)', color: 'rgba(187,247,208,0.95)' }}>
            {msg}
          </div>
        )}
        {error && <div className="auth-alert" role="alert">{error}</div>}

        <form onSubmit={onSubmit} className="auth-form" noValidate>
          <div className="auth-field">
            <label className="auth-label">Business name</label>
            <input
              className="auth-input"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              placeholder="Acme Corp"
              required
            />
          </div>

          <div className="auth-field">
            <label className="auth-label">Email address</label>
            <input
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="auth-field">
            <label className="auth-label">Phone <span style={{ opacity: 0.45, fontWeight: 400 }}>(optional)</span></label>
            <input
              className="auth-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="tel"
              placeholder="+1 (416) 000-0000"
            />
          </div>

          <PasswordInput
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Create a strong password"
            required
          />

          <button className="auth-button" disabled={submitting} type="submit">
            {submitting ? 'Creating account…' : 'Create Account →'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="auth-link">Already have an account? Sign in</Link>
        </div>
      </div>
    </div>
  );
}
